import "./AboutImageFloating.scss";
import { Fragment } from "react";
import { images } from "../../../utils/images";

const AboutImageFloating = ({ img }) => {
  return (
    <Fragment>
      <section className="img_float p_t p_b">
        <img src={images.pattern} alt="Pattern" className="pattern_right" />
        <img src={images.pattern} alt="Pattern" className="pattern_left" />
        <div className="content_wrap">
          <div className="img_wrap">
            <img src={img} alt="about" />
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default AboutImageFloating;
